import baseUrl from "../config/baseUrl";

const getAllFieldTypeList = async ({ token, type }) => {
    try {
        const response = await fetch(
            `${baseUrl}/api/get-fields-setting-data-by-type?fields_tab_type=${type}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const data = await response.json();
        return data;
    } catch (error) {
        return error;
    }
};

export default getAllFieldTypeList;
